import { HttpClient } from '../HttpClient';
/**
 * * Post Archived Attendance Logs
 */
export const PostArchivedAttendanceLogs = async (params) => {
  try {
    const { data } = await HttpClient.post(`api/archivedAttendanceLogs/searchCriteria`, { ...params });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
